import * as actions from './descarte.action';
import inicialState from './descarte.state';

const descarteReducer = (state = inicialState, action) => {
  switch (action.type) {

    case actions.DESCARTE_MATERIAIS_ATUALIZAR_DATAINI:
      return {
        ...state,
        dataInicio: action.payload.dataInicio,
      };
    case actions.DESCARTE_MATERIAIS_ATUALIZAR_DATAFIM:
      return {
        ...state,
        dataFim: action.payload.dataFim,
      };

    case actions.DESCARTE_MATERIAIS_ATUALIZAR_TIPOPERIODO:
      return {
        ...state,
        tipoPeriodo: action.payload.tipoPeriodo,
      };

    case actions.DESCARTE_MATERIAIS_ATUALIZAR_FILTRO_VALUE:
      return {
        ...state,
        filtroValue: action.payload.filtroValue,
      };
   
    case actions.DESCARTE_MATERIAIS_ATUALIZAR_LISTA:
      return {
        ...state,
        lista: action.payload.lista,
      };
   
    case actions.DESCARTE_MATERIAIS_ATUALIZAR_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };
   
    case actions.DESCARTE_MATERIAIS_ATUALIZAR_IMPRIMIR:
      return {
        ...state,
        imprimir: action.payload.imprimir,
      };

    case actions.DESCARTE_MATERIAIS_ATUALIZAR_LISTA_DESCARTE:
      return {
        ...state,
        listaDescarte: action.payload.listaDescarte,
      };
   
    default:
      return state;
  }
};

export default descarteReducer;



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/descarte/store/descarte.reducer.js